import {fromDisplay,measurementUnit,toDisplay} from './units.js';

/** Parse signed field coordinates and directions without accepting partial input,
 * grouping marks, or two different decimal separators in one value. */
export function parseFieldNumber(value,{exponent=false,integer=false}={}) {
  if(typeof value!=='string'||value.length>128)return NaN;
  const text=value.trim();
  if(!text||text.includes('\u066c')||text.includes(',')||text.includes('.')&&text.includes('\u066b'))return NaN;
  const normalized=text.replace(/[\u0660-\u0669\u06f0-\u06f9]/g,digit=>
    String(digit.charCodeAt(0)-(digit.charCodeAt(0)<=0x0669?0x0660:0x06f0))).replace(/\u066b/g,'.');
  const pattern=integer?/^\d+$/:exponent?/^[+-]?(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?$/:/^[+-]?(?:\d+(?:\.\d*)?|\.\d+)$/;
  if(!pattern.test(normalized))return NaN;
  const number=Number(normalized);
  return Number.isFinite(number)?number:NaN;
}

const limitText=(limit,doc,kind,round)=>`${round(toDisplay(limit,doc,kind)*1e4)/1e4} ${measurementUnit(doc,kind)}`.trim();

/** Read one direct-edit measurement typed in the Site's display unit. Incomplete,
 * ambiguous or out-of-range drafts return an operator message and no value. */
export function parseDisplayedMeasurement(text,doc,kind='length',{min=-Infinity,max=Infinity,integer=false}={}) {
  if(integer&&Number.isNaN(parseFieldNumber(text,{integer:true}))&&Number.isFinite(parseFieldNumber(text)))return{error:'Enter a whole number.'};
  const shown=parseFieldNumber(text);
  if(!Number.isFinite(shown))return{error:'Enter a complete number using a point (.) or Arabic decimal mark (٫), without grouping marks.'};
  const value=fromDisplay(shown,doc,kind);
  if(value<min)return{error:`Enter at least ${limitText(min,doc,kind,x=>Math.ceil(x-1e-6))}.`};
  if(value>max)return{error:`Enter at most ${limitText(max,doc,kind,x=>Math.floor(x+1e-6))}.`};
  return{value};
}
